<template>
    <b-overlay
        class="h-100"
        :show="status === 'loading' && !editMode"
    >
        <div class="card-header align-items-start">
            <div class="card-group-title">
                <b-card-title>
                    {{ $t('org.billing.Product Cost') }}
                </b-card-title>
            </div>
            <b-card-actions-container
                v-if="!editMode && ((lastMonthProducts && lastMonthProducts.length) || (thisMonthProducts && thisMonthProducts.length)) && !viewTypeIsMobile"
                class="card-actions-container"
                :open="isVisible"
                @card:collapse="triggerCollapse"
            />
        </div>
        <template v-if="(lastMonthProducts && lastMonthProducts.length) || (thisMonthProducts && thisMonthProducts.length)">
            <div class="position-relative" :style="{ height: 'calc(100% - 78px)'}">
                <ProductCardChart
                    ref="container"
                    :svg="svg"
                    :data="productsCostData"
                    @resize:svg="handleResize"
                    @detail-layer="modalShowDetail"
                >
                </ProductCardChart>
                <div
                    ref="REF_COLLAPSE"
                    :style="collapseResponsiveStyle"
                >
                    <ProductCardTable
                        v-show="!editMode && isVisible"
                        :lastMonthProducts="lastMonthProducts"
                        :thisMonthProducts="thisMonthProducts"
                        @detail-layer="modalShowDetail"
                    ></ProductCardTable>
                </div>
            </div>
        </template>
        <template v-else>
            <div class="d-flex justify-content-center align-items-center flex-column text-center pt-5">
                <SVGEmptyIcon/>
                <span>{{ $t('org.dashboard.No data') }}</span>
            </div>
        </template>
    </b-overlay>
</template>

<script>
import BCardActionsContainer from '@/components/BCardActionsContainer'
import ProductCardChart from './ProductCardChart'
import ProductCardTable from './ProductCardTable'
import useCommonData from '@/composables/useCommonData'
import useDashboard from '@/composables/useDashboard'
import { computed, ref, toRefs, getCurrentInstance, watch } from '@vue/composition-api'
import SVGEmptyIcon from '@/assets/images/empty.svg'
import useDashboardRender from '@/composables/useDashboardRender'
export default {
    components: {
        BCardActionsContainer,
        ProductCardChart,
        ProductCardTable,
        SVGEmptyIcon
    },
    props: {
        editMode: {
            type: Boolean,
            default: false
        },
        isOpen: {
            type: Boolean,
            default: false
        }
    },
    setup (props, context) {
        const vm = getCurrentInstance().proxy
        const { isOpen } = toRefs(props)
        const { viewType } = useDashboardRender()
        const viewTypeIsMobile = computed(() => viewType.value === 'mobile')
        const collapseResponsiveStyle = {
            position: 'absolute',
            left: 0,
            bottom: 0,
            width: '100%'
        }
        const isVisible = ref(false)
        const tableHeight = ref(null)
        const REF_COLLAPSE = ref(null)
        const triggerCollapse = (status) => {
            context.emit('action:showTable', { component: 'summary-card-products', status })
        }
        watch(isOpen, (value, oldValue) => {
            isVisible.value = value
            vm.$nextTick(() => {
                tableHeight.value = value ? vm.$refs['REF_COLLAPSE'].offsetHeight : 0
                handleResize()
            })
        })
        const store = vm.$store
        const svg = ref({
            width: 0,
            height: 0,
            paddingT: 0,
            paddingL: 1.7 * 14,
            paddingR: 1.7 * 14
        })
        const { __toKFormat } = useCommonData()
        const { getSummaryProducts } = useDashboard()
        const currentParams = computed(() => store.getters['$_dashboard/currentParams'])
        const [status, productsCostData] = getSummaryProducts(currentParams.value)
        const thisMonthProducts = computed(() => productsCostData.value.thisMonthProducts || [])
        const lastMonthProducts = computed(() => productsCostData.value.lastMonthProducts || [])
        const modalShowDetail = (productCode) => {
            if (productCode.toLowerCase() !== 'etc') {
                context.emit('modal:showDetail', { productCode })
            }
        }
        const container = ref(null)
        const handleResize = () => {
            if (container.value) {
                svg.value.width = container.value.$el.clientWidth - svg.value.paddingL - svg.value.paddingR
                svg.value.height = container.value.$el.clientHeight - 77 - 14 - tableHeight.value
            }
        }
        watch(currentParams, (value, oldValue) => {
            getSummaryProducts(value)
        }, {
            deep: true
        })
        return {
            REF_COLLAPSE,
            status,
            svg,
            container,
            productsCostData,
            thisMonthProducts,
            lastMonthProducts,
            __toKFormat,
            modalShowDetail,
            // toggleMode,
            handleResize,
            isVisible,
            triggerCollapse,
            collapseResponsiveStyle,
            viewTypeIsMobile
        }
    }
}
</script>

<style>
#containerProductCard text.shadow {
    text-shadow: #000 2px 2px 10px
}
#containerProductCard .list-enter-active, #containerProductCard .list-leave-active {
    transition: all 1s;
}
#containerProductCard .list-enter, #containerProductCard .list-leave-to  {
    opacity: 0;
    transform: translateY(-30px);
}
</style>
